"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorPage = ErrorPage;
const react_1 = __importDefault(require("react"));
const components_1 = require("@alcumus/components");
const react_router_dom_1 = require("react-router-dom");
const NavBar_1 = __importDefault(require("../NavBar"));
const core_1 = require("@material-ui/core");
const react_i18next_1 = require("react-i18next");
const useStyles = (0, core_1.makeStyles)(() => ({
    body: {
        whiteSpace: 'pre-line',
    },
    customNavLink: {
        color: components_1.StyleVariables.colors.text.default,
        textDecoration: 'underline',
        '&:hover': {
            color: components_1.StyleVariables.colors.action.primary.default,
        },
    },
    buttonText: {
        fontWeight: components_1.StyleVariables.fonts.weight.semiBold,
        lineHeight: components_1.StyleVariables.fonts.lineHeight.h5,
    },
    buttonBase: {
        borderRadius: 100,
        padding: '8px 24px',
    },
}));
function ErrorPage({ buttonText, headerText, t, tReady }) {
    const history = (0, react_router_dom_1.useHistory)();
    const classes = useStyles();
    const link = 'https://support.ecompliance.com/hc/en-us/requests/new';
    const handleClick = () => {
        history.goBack();
    };
    return (react_1.default.createElement(components_1.TranslateReady, { tReady: tReady },
        react_1.default.createElement(NavBar_1.default, null,
            react_1.default.createElement(components_1.Error, { header: headerText ?? t('headerText'), body: react_1.default.createElement(components_1.Text, { center: true, "data-testid": "body", className: classes.body },
                    react_1.default.createElement("span", null, `${t('errorPageContact')} \n`),
                    `${t('at')} `,
                    react_1.default.createElement("a", { href: link, className: classes.customNavLink }, link),
                    `${t('errorPageContactNumber')}`), imgSrc: "/images/error.svg" },
                react_1.default.createElement(components_1.Button, { "aria-label": "refresh-button", uppercase: false, rounded: true, className: classes.buttonBase, onClick: handleClick, "data-testid": "base-button" },
                    react_1.default.createElement(components_1.Text, { center: true, className: classes.buttonText }, buttonText ?? t('errorPageDefaultButton')))))));
}
exports.default = (0, react_i18next_1.withTranslation)('ErrorPage')(ErrorPage);
